export enum RealmOrigin {
  Storro = 'Storro',
  AgencyDrive = 'AgencyDrive',
}
